<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
  >
    <!-- 订单详情 -->
    <template #ORDERDETAIL="{ params, visible }">
      <order
        v-if="visible"
        :orderDetails="params.dataDetails"
        :pageText="params.pageText"
        :footer-hide="false"
      ></order>
    </template>
    <template #PREVIEW="{ params, visible }">
      <Carousel v-if="typeof params.src !== 'undefined'">
        <CarouselItem v-for="(item, k) in params.src.payload" style="height: 480px; text-align: center; background-color: #fff;">
          <img :src="item" style="max-height: 480px; max-width: 480px;"  alt=""/>
        </CarouselItem>
      </Carousel>
    </template>
    <!-- 订单轨迹 -->
    <template #ORDERTRACKER="{ params, visible }">
      <order-tracker
        type="all"
        :statusId="params.id"
        v-if="visible"
      ></order-tracker>
    </template>
    <!-- 入库大图 -->
    <template #INBOUNDPROOF="{ params, visible }">
      <Carousel v-if="typeof params.src !== 'undefined'">
        <CarouselItem v-for="(item, k) in params.src" style="width: 960px; height: 480px; text-align: center; background-color: #fff;">
          <img :src="item" style="max-height: 480px; max-width: 960px;"  alt=""/>
        </CarouselItem>
      </Carousel>
    </template>
  </cTable>
</template>

<script>
import {
  getOrderDetails,
  getOrder,
  getOrderStatus,
  getOrderType,
  postSheet,
  postPdf,
  returnPlan,
  getTimeType,
  confirmWeight,
  checkWeight,
  addNewRemark,
  getOtherFee,
  addOtherFee,
  getRemark,
  log,
  batchDelOrder,
  blockOrder,
  signPic,
  unbox,
  removeBlocks,
  changeTemuAccount
} from "@/api/order/list";
import { getAllService } from "@/api/user/internal";
import { getStatus } from "@/api/tracker/status";
import { getUser } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
import { getAllClient } from "@/api/user/client";
import { getAgent } from "@/api/tracker/agent";
import { getWarehouse } from "@/api/storage/warehouse";
import { getSelectType, getKeysType, getGroupName } from "@/api/public";
import { getCompanyConfig } from "@/api/user/branch";
import { getCurrency } from "@/api/finance/currency";
// import { getSelAgent } from "@/api/public";
import cTable from "@/base/common/index.vue";
import order from "_c/order-details";
import { fields } from "./fields";
import { header } from "./header";
import { modals } from "./modals";
import orderTracker from "@/base/order_tracker";
import Temp from "@/view/finances/handle_fee/temp.vue";
export default {
  components: {
    Temp,
    cTable,
    order,
    orderTracker
  },
  props: {
    type: {
      type: String,
      default: "order"
    }
  },
  methods: {
    getFun(fun, params) {
      return eval(fun);
    }
  },
  data() {
    return {
      img: "",
      methods: {
        list: p => {
          switch (this.type) {
            // 入库单
            case "inbound":
              p["codeStatus"] = 300;
              break;
            //待客户确认重量
            case "customer-wait":
              p["should_block"] = "WAIT_CONFIRM";
              break;
            // 客户拦截
            case "customer-in":
              p["should_block"] = "CLIENT_REQUEST";
              break;
            // 删除订单
            case "delete":
              p["invalid"] = "YES";
              break;
          }
          if (this.$route.params) {
            for (const key in this.$route.params) {
              p[key] = this.$route.params[key];
            }
          }
          return getOrder(p);
        },
        getOrderDetails,
        getOrderStatus,
        getOrderType,
        postSheet,
        postPdf,
        returnPlan,
        getTimeType,
        confirmWeight,
        getUser,
        getCountry,
        // getAllClient,
        getAgent,
        getWarehouse,
        checkWeight,
        getSelectType,
        addNewRemark,
        getOtherFee,
        addOtherFee,
        getStatus,
        getCompanyConfig,
        getCurrency,
        getRemark,
        getAllService,
        getGroupName,
        log,
        batchDelOrder,
        blockOrder,
        signPic,
        unbox,
        removeBlocks,
        changeTemuAccount
      },
      modals: {},
      header: {
        searchs: []
      },
      fields: [],
      isSearch: false
    };
  },
  watch: {
    // isSearch(val) {
    //   if (val) {
    //     this.$refs.table.getList();
    //   }
    // }
  },
  created() {
    this.isSearch = false;
    this.$nextTick(async () => {
      let that = this.$refs["table"];
      this.header = header({ that, type: this.type });
      this.fields = fields({ that, type: this.type });
      this.modals = modals({ that, type: this.type });
      await this.header.searchs.forEach(async item => {
        if (item.show && item.show() == false) return;
        // 请求筛选数据
        if (item.getFun) {
          let res = item.isPublic
            ? (await this.methods[item.getFun](item.searchData)).data.payload[
                item.searchData
              ]
            : (await this.methods[item.getFun](item.searchData)).data.payload;
          if (item.getFilter) {
            let data = [];
            item.getFilter.forEach(item => {
              data = data.concat(res[item]);
            });
            item.options = data;
          } else {
            item.options = Array.isArray(res) ? res : res.rows;
          }
          if (item.isDefault) {
            that.$refs["header"].searchForm[item.key] = res[0][item.isDefault];
          }
          if (
            Object.keys(this.$route.params).length > 0 &&
            this.$route.params[item.key]
          ) {
            that.$refs["header"].searchForm[item.key] = this.$route.params[
              item.key
            ];
          }
          //   if (item.isSearch) {
          //     let setT = setTimeout(() => {
          //       this.isSearch = true;
          //     }, 0);
          //   }
          // }
        }
      });
      this.$refs["table"].resize();
    });
  }
};
</script>

<style lang="scss" scoped></style>
